// import { useTheme } from '@/controller/ThemeContext';
import React from 'react';

import NetworkAddToWallet from 'ui/shared/NetworkAddToWallet';

function SectionTop() {
  return (
    <div style={{ background: '#050b18', paddingBottom: '2rem' }}>
      <div className="container footer-section-top-wrapper ">
        <NetworkAddToWallet/>
      </div>
    </div>
  );
}

export default SectionTop;
